import React from "react";
import styled, { css } from "styled-components";
import * as colors from "../../assets/_base/colors";
import MaskedInput from "react-input-mask";
import { useFieldValue } from "./hooks";
import baseStyle from "./style";
import Text from "../../_components/Text";
import Date from "./components/Date";
import Currency from "./components/Currency";
import Select from "./components/Select";
import CNPJ from "./components/CNPJ";

const DEFAULT_MAX_LENGTH = 12;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 10px;

  label {
    margin-bottom: 5px;
    font-weight: bold;
  }
  i {
    position: absolute;
    right: 20px;
    bottom: 40px;
    cursor: pointer;
  }
  ${(props) => (props.hide ? "display: none;" : "display: block;")}
`;

const Input = styled.input`
  ${baseStyle};

  ${(props) => {
    if (props.invalid) {
      return css`
        border: 1px solid ${colors.danger};
        color: ${colors.danger};

        :focus,
        :active {
          border: 2px solid ${colors.danger};
          color: ${colors.danger};
        }
      `;
    }
  }}
`;
const MaxLength = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  font-weight: bold;
`;

export default (props) => {
  const [isValid, setIsValid] = React.useState(true);

  function checkIsValid() {
    if (props.value) {
      setIsValid(props.value.length > (props.maxLength || DEFAULT_MAX_LENGTH));
    }
    return setIsValid(true);
  }

  function onChange(e) {
    const { value } = e.target;
    if (props.onChange) {
      props.onChange(value);
    }
    checkIsValid();
  }
  function clearInput() {
    if (props.onChange) {
      props.onChange("");
    }
    checkIsValid();
  }

  return (
    <Wrapper>
      <label>{props.label}</label>
      <Input
        isValid={isValid}
        onChange={onChange}
        value={props.value}
        placeholder={props.placeholder}
        maxLength={props.maxLength}
      />
      <MaxLength>
        {props.value ? props.value.length : 0}/
        {props.maxLength || DEFAULT_MAX_LENGTH}
      </MaxLength>
      <i onClick={clearInput} className="fas fa-close" />
    </Wrapper>
  );
};

export function _Input(props) {
  const [getFieldNameValue] = useFieldValue();

  function onChange(e, doubleValue) {
    if (props.onChange) {
      const data = getFieldNameValue(props, e, doubleValue);
      props.onChange(data);
    }
  }

  if (!props.type || props.type === "text" || props.type === "password") {
    return (
      <Wrapper>
        {props.label ? (
          <Text fontSize="1.2em">{props.label}</Text>
        ) : (
          <React.Fragment />
        )}
        <Input
          {...props}
          onChange={onChange}
          disabled={props.loading || props.disabled}
        />
        {props.invalid ? (
          <Text color="danger">
            {props.errorText ? props.errorText : "Corrija este campo."}
          </Text>
        ) : (
          <React.Fragment />
        )}
      </Wrapper>
    );
  }else if (props.type === "cnpj") {
    return (
      <Wrapper>
        {props.label ? (
          <Text fontSize="1.2em">{props.label}</Text>
        ) : (
          <React.Fragment />
        )}
        <CNPJ
          {...props}
          onChange={props.onChange}
          disabled={props.loading || props.disabled}
        />
        {props.invalid ? (
          <Text color="danger">
            {props.errorText ? props.errorText : "Corrija este campo."}
          </Text>
        ) : (
          <React.Fragment />
        )}
      </Wrapper>
    );
  } else if (props.type === "select") {
    return (
      <Wrapper>
        {props.label ? <Text fontSize="1.2em">{props.label}</Text> : <React.Fragment />}
        <Select
          {...props}
          options={props.options || []}
          onChange={onChange}
          disabled={props.loading || props.disabled}
        />
      </Wrapper>
    );
  } else if (props.type === "date") {
    return (
      <Wrapper>
        {props.label ? <Text fontSize="1.2em">{props.label}</Text> : <React.Fragment />}
        <Date
          disabled={props.loading || props.disabled}
          onChange={props.onChange}
          minDate={props.minDate}
          maxDate={props.maxDate}
          value={props.value}
        />
      </Wrapper>
    );
  } else if (props.type === "currency") {
    return (
      <Wrapper>
        {props.label ? <Text fontSize="1.2em">{props.label}</Text> : <React.Fragment />}
        <Currency
          invalid={props.invalid}
          disabled={props.loading || props.disabled}
          onChange={props.onChange}
          value={props.value}
        />
        {props.invalid ? (
          <Text color="danger">Corrija este campo.</Text>
        ) : (
          <React.Fragment />
        )}
      </Wrapper>
    );
  } else if (props.type === "phone_number" || props.type === "phone") {
    return (
      <Wrapper>
        {props.label ? <Text fontSize="1.2em"> {props.label}</Text> : <React.Fragment />}
        <MaskedInput
          disabled={props.loading || props.disabled}
          {...props}
          onChange={onChange}
          mask={"(99) 99999-9999"}
        >
          {({ inputProps }) => (
            <_Input
              disabled={props.loading || props.disabled}
              {...inputProps}
            />
          )}
        </MaskedInput>
      </Wrapper>
    );
  } else {
    return (
      <Wrapper>
        {props.label ? <Text fontSize="1.2em">{props.label}</Text> : <React.Fragment />}
        <Input
          {...props}
          onChange={onChange}
          value={props.value}
          disabled={props.loading || props.disabled}
        />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/Input/index.jsx